import React from 'react';
import { IconTheme } from '../../IconsCommonTypes';

function User(theme: IconTheme | undefined = undefined) {
  return !theme?.applyZoom ? (
    <svg
      width={theme && theme.width ? theme.width : '44'}
      height={theme && theme.height ? theme.height : '44'}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9999 10.8167C24.1266 10.8167 25.8499 12.54 25.8499 14.6667C25.8499 16.7934 24.1266 18.5167 21.9999 18.5167C19.8733 18.5167 18.1499 16.7934 18.1499 14.6667C18.1499 12.54 19.8733 10.8167 21.9999 10.8167ZM21.9999 27.3167C27.4449 27.3167 33.1833 29.9934 33.1833 31.1667V33.1834H10.8166V31.1667C10.8166 29.9934 16.5549 27.3167 21.9999 27.3167ZM21.9999 7.33337C17.9483 7.33337 14.6666 10.615 14.6666 14.6667C14.6666 18.7184 17.9483 22 21.9999 22C26.0516 22 29.3333 18.7184 29.3333 14.6667C29.3333 10.615 26.0516 7.33337 21.9999 7.33337ZM21.9999 23.8334C17.1049 23.8334 7.33325 26.29 7.33325 31.1667V36.6667H36.6666V31.1667C36.6666 26.29 26.8949 23.8334 21.9999 23.8334Z"
        id="User"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
    </svg>
  ) : (
    <svg
      width={theme && theme.width ? theme.width : '26'}
      height={theme && theme.height ? theme.height : '26'}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9999 6.46418C14.2428 6.46418 15.2499 7.47132 15.2499 8.71418C15.2499 9.95704 14.2428 10.9642 12.9999 10.9642C11.757 10.9642 10.7499 9.95704 10.7499 8.71418C10.7499 7.47132 11.757 6.46418 12.9999 6.46418ZM12.9999 16.107C16.182 16.107 19.5356 17.6713 19.5356 18.357V19.5356H6.46418V18.357C6.46418 17.6713 9.81775 16.107 12.9999 16.107ZM12.9999 4.42847C10.632 4.42847 8.71418 6.34632 8.71418 8.71418C8.71418 11.082 10.632 12.9999 12.9999 12.9999C15.3678 12.9999 17.2856 11.082 17.2856 8.71418C17.2856 6.34632 15.3678 4.42847 12.9999 4.42847ZM12.9999 14.0713C10.1392 14.0713 4.42847 15.507 4.42847 18.357V21.5713H21.5713V18.357C21.5713 15.507 15.8606 14.0713 12.9999 14.0713Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
    </svg>
  );
}

export default User;
